export * from 'cf-core/src/images'
export const Hero404 = 'https://d24rddnpxh8ji7.cloudfront.net/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://d24rddnpxh8ji7.cloudfront.net/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/yelp.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/facebook.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/zomato.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1652237594/chickenplus/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1649183138/grandcrystal/orderPickupButton_34.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1585671918/cafesaladedefruits/saladedefruits_instagram.png'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1591377852/general/cflogo_black.png'
export const aboutText =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1589305503/amigopancake/aboutText.png'
export const headerBg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1589305503/amigopancake/headerBg.jpg'
export const about = 'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/About.jpg'
export const contactbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1652238682/chickenplus/footer.jpg'
export const foodGallery =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/foodGallery2.webp'
export const hero = 'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/hero.webp'
export const heroText =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/heroText.webp'
export const homebg = 'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/bg.jpg'
export const locationMap =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/map.webp'
export const logo =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/webLogo.png'
export const logoTitle =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/Title.png'
export const mobileAbout =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/mobileAbout.webp'
export const mobileContactbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1652240990/chickenplus/mobileContact.jpg'
export const mobileGallery =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/mobileAbout.webp'
export const mobileHero =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/mobileHero.webp'
export const mobileHeroText =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/leHeroText3.png'
export const mobileLogo =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse//mobileLogo.png'
export const mobileMap =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/mobileMap.webp'
export const mobilePromotion1 =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/mobilePromoTop.webp'
export const mobilePromotion2 =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/mobilePromo2.webp'
export const orderDeliveryButton =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/rDeliveryButton.png'
export const orderPickupButton =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/orderPickupButton.webp'
export const promotions =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/promotions2.webp'
export const menu = 'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/Menu.pdf'
export const banner =
  'https://d24rddnpxh8ji7.cloudfront.net/bluehouse/banner.jpg'

export { default as notice } from './notice.jpeg'
